import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'

export const MusicPageTemplate = ({ title, content, contentComponent, releases }) => {
  const PageContent = contentComponent || Content

  const releasesContent = releases.map((r, index) => {
    return(
      <div className="release" key={index}>
        <hr />
        <div className="columns">
          <div className="column is-4">
            <HTMLContent className="release__embed-code" content={r.embed_code} />
          </div>
          <div className="column is-8">
            <h3>{r.name}</h3>
            <HTMLContent className="release__description" content={r.description} />
          </div>
        </div>
      </div>
    )
  })

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <div className="section">
            <h2 className="title is-bold-light">
              {title}
            </h2>
            <PageContent className="content" content={content} />
            {releasesContent}
          </div>
        </div>
      </div>
    </div>
  )
}

MusicPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
  releases: PropTypes.array
}

const MusicPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <MusicPageTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
        releases={post.frontmatter.releases}
      />
    </Layout>
  )
}

MusicPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default MusicPage

export const musicPageQuery = graphql`
  query MusicPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        releases {
          name
          embed_code
          description
        }
      }
    }
  }
`
